import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';



var url =  window.location.hostname;
var port = window.location.port;
const Heading = [['ID','Warehouse', 'Brand', 'Beat Name','Area Code','Delivery Center', 'Packing Method']]
const Heading1 = [['Beat Name','Brand','Retailer Code']]





class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();
   this.fetchBinData = this.fetchBinData.bind(this);
   this.toggle = this.toggle.bind(this);
   this.toggleFailed = this.toggleFailed.bind(this);


    this.state = {
	  loading_overlay: false,	
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      beat_retailer_data: [],
      loadingGRNData: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      showResponseData: false,
      showBaseResponseData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      loading: false,
      isLoading:true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
  
    };
  }


  componentDidMount(){
  this.fetchBinData();
  this.fetchBeatRetailerData();
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = Util.getCookie('token');
      var location = Util.getCookie('selectedLocation');
      var username = Util.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

 

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));  
  }

   fetchBeatRetailerData(){


     


     const payload={master_type: "beat_retailer_mapping",
     }
API.post('/customer/view/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         console.log("Area Data",data);

         // if (err) throw err;

         this.setState({beat_retailer_data: data.data })

      })

      .then(async() => {

         //this.setState({ tableRows:this.assemblePosts(), isLoading:false })

         //console.log(this.state.tableRows);

      });
  }
 

  fetchBinData(){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
		loading_overlay:true
      })


     const payload={master_type: "beat_area_crossdock",
     location: this.state.selectedLocation,}
API.post('/customer/view/v1/', { param: payload })

      .then(response => response.data)

      .then(data => {

         console.log("Area Data",data);

         // if (err) throw err;

         this.setState({posts: data.data })

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), isLoading:false })

         console.log(this.state.tableRows);

      });
  }


 
 

  assemblePosts= () => {

    let posts =this.state.posts.map((post) => {

      return (

        {
          warehouse: post.warehouse,
          brand: post.brand,
          beat_name: post.beat_name,

          area_code: post.area_code,
          delivery_center: post.delivery_center,
          packing_method: post.packing_method


          

        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }


 
 
  render() {
    const { handleSubmit, reset, t } = this.props;
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;


    const data = {

      columns: [
        {

          label:'Warehouse',

          field:'warehouse',
          sort: 'asc',

        },
        {

          label:'Brand',

          field:'brand',
          sort: 'asc',

        },
        {

          label:'Beat Name',

          field:'beat_name',
          sort: 'asc',

        },

        {

          label:'Area Code',

          field:'area_code',
          sort: 'asc',

        },

        {

          label:'Delivery Center',

          field:'delivery_center',
          sort: 'asc',

        },

         {

          label:'Packing Method',

          field:'packing_method',
          sort: 'asc',

        },
        

      ],

      rows:this.state.tableRows,

    }


   

    return (
      <Col xl={12}>
	       {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          

          {
            this.state.showFetchBinData  && (

          <CardBody style={{marginTop: 20}}>
            <div className="table_header" style={{borderBottomWidth:'0px', padding: 0, margin: 0}}>

            
            <button style={{backgroundColor: '#FBBB00', color: 'black'}} className="modal_ok"  onClick={() => exportToCSV(this.state.beat_retailer_data, "Beat Retailer Mapping", Heading1)}>Download Beat Retailer</button>
          
              
              
              
			  <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.posts, "BeatAreaMaster", Heading)}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

            </div>
			<hr style={{marginTop:'10px',marginBottom:'0px'}}/>
            <MDBDataTable
            striped
            bordered
            sortable={false}
            hover
            data={data}
            onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'category_master_view', 'datatable_pagination_change' )}
          />
          </CardBody>

          )}



        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Cancel</Button>
            
          </ButtonToolbar>
        </Modal>

      


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));